// extracted by mini-css-extract-plugin
export var emailBlockLink = "_j2-0";